var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"justified-container",style:(_vm.style)},_vm._l((_vm.layout),function(box,index){return _c('div',{key:index,staticClass:"justified-item",style:(box.style)},[_vm._t("default",null,{"item":box.item,"index":index})],2)}),0)}
var staticRenderFns = []

export { render, staticRenderFns }